import React from "react";

import { Label } from "semantic-ui-react";

import IconTurnAroundTime from "./IconTurnAroundTime";

// Types
type SubLabNameFormatProps = {
  cancelSummary?: string;
  itemStatus: string;
  status: string;
  summary: {
    exceed_turn_around_time?: string | null;
    title: string;
    turn_around_time_hr?: number;
    turn_around_time_min?: number;
  }[];
};

const SubLabNameFormat = (props: SubLabNameFormatProps) => (
  <>
    {props.status === "CANCELED" ? (
      <div dangerouslySetInnerHTML={{ __html: props.cancelSummary || "" }} />
    ) : (
      props.summary.map((item) => (
        <React.Fragment key={`summary-item-${item.title}`}>
          <span
            dangerouslySetInnerHTML={{ __html: item.title }}
            style={{ paddingRight: "0.275rem" }}
          />
          <IconTurnAroundTime
            exceedTime={item.exceed_turn_around_time}
            hr={item.turn_around_time_hr}
            min={item.turn_around_time_min}
            style={{ marginBottom: "-3px" }}
          />
        </React.Fragment>
      ))
    )}

    {props.itemStatus === "SPECIMEN_REJECTED" && (
      <>
        <br />
        <Label color="red">Reject</Label>
      </>
    )}
  </>
);

SubLabNameFormat.displayName = "SubLabNameFormat";

export default React.memo(SubLabNameFormat);
